import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorCode, ERROR_ROUTES, ResourceType } from './error.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private readonly router = inject(Router);

  navigateToError(code: ErrorCode): void {
    const route = ERROR_ROUTES[code];
    this.router.navigate([route.path]);
  }

  // `string & {}` keeps ResourceType autocomplete while allowing any resource
  // name; the page translates known ones and echoes the rest verbatim.
  notFound(resource: ResourceType | (string & {})): void {
    const route = ERROR_ROUTES[ErrorCode.NOT_FOUND];
    this.router.navigate([route.path], { queryParams: { resource } });
  }
}
